import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import moment from 'moment-timezone';

@Pipe({
  name: 'rtDaysLeft',
  standalone: true,
})
export class DaysLeftPipe implements PipeTransform {
  public transform(date: string | Date, { round }: { round: boolean } = { round: false }): number {
    const diffInDays = moment().diff(date, 'days', true) * -1;
    const days = round ? Math.round(diffInDays) : diffInDays;

    if (days > 0) {
      return days;
    } else {
      return 0;
    }
  }
}
